function openOnglet(ongletActive, section, index) {
	const sectionElement = document.querySelector(section);

	const ongletAll = sectionElement.querySelectorAll(".mm-bd-onglet-title");
	ongletAll.forEach(function (onglet) {
		if (onglet === ongletActive) {
			onglet.classList.add("mm-active");
		} else {
			onglet.classList.remove("mm-active");
		}
	});

	const contentAll = sectionElement.querySelectorAll(".mm-bd-onglets-content");
	const contentActive = `mm-bd-onglets-content-${index}`;

	contentAll.forEach(function (content) {
		if (content.classList.contains(contentActive)) {
			content.classList.add("active");
		} else {
			content.classList.remove("active");
		}
	});
	adjustBackgroundSize(sectionElement);
}

function adjustBackgroundSize(section) {
	const ongletActive = section.querySelector(".mm-bd-onglet-title.mm-active");
	const bgActive = document.querySelector(".mm-bd-onglet-title-bg");

	if (ongletActive && bgActive) {
		const rect = ongletActive.getBoundingClientRect();
		const containerRect = ongletActive.parentElement.getBoundingClientRect();

		bgActive.style.width = rect.width + "px";
		bgActive.style.height = rect.height + "px";
		bgActive.style.top = rect.top - containerRect.top - 1 + "px";
		bgActive.style.left = rect.left - containerRect.left - 1 + "px";
	}
}

if (window.innerWidth > 1200) {
  document.addEventListener("DOMContentLoaded", function () {
    const sectionOnglets = document.querySelectorAll(".mm-section-bloc-details .mm-section");
    sectionOnglets.forEach((section) => {
      adjustBackgroundSize(section);
    });
  });
}
